import { Anchor, Text } from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../../api/client";
import { Page } from "../../shared/ui/Page";

export function VerifyEmailPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const [state, setState] = useState<"working" | "done" | "failed">("working");
  const sent = useRef(false);
  useEffect(() => {
    if (sent.current) return; // StrictMode runs effects twice; the link is single use
    sent.current = true;
    const token = params.get("token") ?? "";
    void api
      .POST("/auth/verify-email", { body: { token } })
      .then(({ response }) => setState(response.ok ? "done" : "failed"));
  }, [params]);
  return (
    <Page title={t("verify_email.title")}>
      <Text role="status" data-testid="verify-email-status">
        {t(`verify_email.${state}`)}
      </Text>
      <Anchor component={Link} to="/">
        {t("nav.home")}
      </Anchor>
    </Page>
  );
}
